export default __webpack_public_path__ + "static/media/lock-open.32d8dc5c.svg";